import { ApolloProvider as DefaultApolloProvider } from '@apollo/client'
import React from 'react'

import { useGraphQL } from '../../hooks'

export const ApolloProvider: React.FC<{children: any}> = ({ children }) => {
  const client = useGraphQL()
  return <DefaultApolloProvider client={client}>{children}</DefaultApolloProvider>
}
